module.exports = __webpack_public_path__ + "static/media/step1@2x.bcab5653.mov";